<template>
  <div>
  <div>Portfolio</div>
  <p>Coming soon...</p>
  </div>
</template>

<script>
export default {
  beforeMount () {
    this.$store.commit('setActualRoute', this.$route.name)
  },
  mounted () {
    this.$store.commit('setBannerTitle', 'Portfolio')
  }
}
</script>

<style>

</style>
